import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  host: { 'test-id': 'operation-cancel-popover-body' },
  selector: 'operation-cancel-popover-body',
  templateUrl: './operation-cancel-popover-body.component.html',
  styleUrls: ['./operation-cancel-popover-body.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperationCancelPopoverBodyComponent {
  @Input() title: string;
  @Input() text: string;
  @Input() submitTitle: string;
  @Input() cancelTitle: string;

  @Output() readonly onSubmitClick = new EventEmitter<void>();
  @Output() readonly onCancelClick = new EventEmitter<void>();
}
